import { writable, derived } from 'svelte/store';
import { BigNumber } from 'bignumber.js';

export const mainData = writable({
    aanvullend: 7181.87,
    reisproduct: 5988.83,
    collegegeld: 11334.29,
    lening: 50000.00,
    maandloon: 2000,
    beginMaand: '2015-08-01',
    eindMaand: '2022-07-01',
    rente: 0.005,
    prestatiebeurs: 1,
});

export const siteData = writable({
    pw: "leids",
    showForm: false,
    loggedIn: false
});